<template>
<div class="chapter">
<div class="inner_page">
<div class="copyright" id="cop">
<p class="crt">This is a work of fiction. Names, characters, places, and incidents either are the product of the author’s imagination or are used fictitiously, and any resemblance to actual persons, living or dead, business establishments, events, or locales is entirely coincidental.</p>
<p class="crt">SPEC OPS SQUAD: DEEP STRIKE</p>
<p class="crt">Originally published by Ace in July 2002. Published as an ebook by Jabberwocky Literary Agency in July 2011.</p>
<p class="crt">Copyright © 2002 by Rick Shelley.<br/>Cover art by Dirk Berger.</p>
<p class="crt">All rights reserved.<br/>This book, or parts thereof, may not be reproduced in any form without permission. For more information, visit our website at http://www.awfulagent.com.</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 9781936535415_epub_cop_r1.vue?8b086c90